/**
 * Copyright 2023 Design Barn Inc.
 */

import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import React from 'react';

import { getFormattedSearchParamsString } from '../../utils/url-params';


export default function CardFooter(): React.ReactElement {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  let content = (
    <>
      New to LottieFiles?{' '}
      <Link href={`/register${getFormattedSearchParamsString(searchParams)}`} className="text-action-primary hover:text-action-primary-hover">
        Create an account
      </Link>
    </>
  );

  if (pathname.includes('/register')) {
    content = (
      <>
        Already have an account?{' '}
        <Link
          href={`/login${getFormattedSearchParamsString(searchParams)}`}
          className="text-action-primary hover:text-action-primary-hover"
        >
          Log in
        </Link>
      </>
    );
  }

  if (pathname.includes('/mfa') || pathname.includes('/backup-codes')) {
    content = (
      <>
        Need help?{' '}
        <Link
          href="https://help.lottiefiles.com/hc/en-us/requests/new"
          className="text-action-primary hover:text-action-primary-hover"
        >
          Contact support
        </Link>
      </>
    );
  }

  return (
    <>
      <div className="h-[1px] w-full bg-gray-100" />
      <div className="rounded-2xl p-4 flex justify-center">
        <p className="text-gray-500">{content}</p>
      </div>
    </>
  );
}
